import { createAction, props } from '@ngrx/store';

import type { Outlet } from 'src/app/utils/models/outlet.interface';

export enum DealerActionType {
  StartLoad = '[Dealer-Locator] Start Load',
  FinishLoad = '[Dealer-Locator] Finish Load',
  ClearState = '[Dealer-Locator] Clear State'
}

export const dealerLocatorStartLoadAction = createAction(
  DealerActionType.StartLoad,
  props<{
    payload: {
      outletId: string;
    };
  }>()
);

export const dealerLocatorFinishLoadAction = createAction(
  DealerActionType.FinishLoad,
  props<{
    payload: {
      outlet: Outlet;
    };
  }>()
);

export const dealerLocatorClearStateAction = createAction(DealerActionType.ClearState);
